module.exports = __webpack_public_path__ + "img/v4_adminRole.0d33ece5.png";